import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { authenticationService } from '../../services/authenticationService';

export const PrivateRoute = ({ component: Component, componentLayout: ComponentLayout, routes, pageName, path,...rest }) => (
    <Route {...rest} render={props => {
        const currentUser = authenticationService.currentUserValue;
        if (!currentUser) {
            // not logged in so redirect to login page with the return url
            return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        }

        // authorised so return component
        return <ComponentLayout routes={routes} pageName={pageName} path={path} childComponent={Component}></ComponentLayout>
    }} />
)
